import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledModalBody = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 30px;
`;

const StyledRowsList = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 20px;
`;

const StyledRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 10px;
`;

const StyledRowLabel = styled(Text)`
	font-size: 16px;
	color: #ffffff;
	opacity: 0.5;
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 10px;
`;

const StyledRowValue = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	& > ${Text} {
		font-size: 16px;
		font-weight: 500;
		color: #ffffff;

		span {
			opacity: 0.5;
			font-weight: 400;
		}
	}
`;

export {
	StyledButtonsContainer,
	StyledModalBody,
	StyledRow,
	StyledRowLabel,
	StyledRowsList,
	StyledRowValue,
};
